import {
  Box,
  Circle,
  CloseIcon,
  HbTooltip,
  HStack,
} from '@cdl/heartbeat-react';
import { formatName } from '../../../utils/task.utils';
import { CustomCircle } from '../../../../../shared/components/circle/CustomCircle';

type Props = {
  selectedOptions: string[];
  getDisplayNameById: (id: string) => string;
  handleDeselectOption: (optionToDeselect: string) => void;
};

export const DisplaySelectedAnnotators: React.FC<Props> = ({
  selectedOptions,
  getDisplayNameById,
  handleDeselectOption,
}) => {
  return (
    <HStack spacing='s'>
      {selectedOptions.map((el, index) => (
        <HbTooltip
          label={getDisplayNameById(el)}
          placement='top-start'
          key={index}
        >
          <Box position='relative' p='xxs'>
            <CustomCircle size='40px'>
              {formatName(getDisplayNameById(el))}
            </CustomCircle>
            <Circle
              border='1px'
              borderColor='neutral.100'
              position='absolute'
              bg='white'
              _hover={{ border: '0px' }}
              top='0'
              right='0'
              cursor='pointer'
            >
              <CloseIcon
                color='neutral.200'
                onClick={() => handleDeselectOption(el)}
              />
            </Circle>
          </Box>
        </HbTooltip>
      ))}
    </HStack>
  );
};
